module.exports = __webpack_public_path__ + "assets/veritas_slider1.2afb5710.jpg";